__webpack_require__.p = "https://sohailmh.na.safety-genie.whs.amazon.dev/";